import { useFormikContext } from 'formik'
import { IncludePropertiesInput as Input } from 'ui-components'
import { useVisualisations } from '~map-preview/states/map'
import { Values } from '../Form/types'

const IncludePropertiesInput = () => {
  const properties = useVisualisations()

  const form = useFormikContext<Values>()

  return (
    <Input
      // Hide when the properties is less than or equal to one
      hidden={properties.length <= 1}
      disabled={properties.length <= 0 || form.isSubmitting}
      value={form.values.includeProperties}
      options={properties}
      onChange={(event, value) => {
        form.setFieldValue('includeProperties', value)
      }}
    />
  )
}

export { IncludePropertiesInput }
